var _rect, _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoFarecards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 311,
    height: 201,
    viewBox: "0 0 311 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.963867,
    width: 310.538,
    height: 199.909,
    rx: 6,
    fill: "#005DAA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 99.5,
    r: 41.5,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6715_12023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.834 99.4997H174.167V90.6663H138.834V99.4997ZM171.959 121.583V114.958H165.334V110.541H171.959V103.916H176.375V110.541H183V114.958H176.375V121.583H171.959ZM138.834 117.166C137.619 117.166 136.579 116.734 135.713 115.868C134.848 115.002 134.416 113.963 134.417 112.75V86.2497C134.417 85.0351 134.85 83.995 135.715 83.1293C136.581 82.2636 137.621 81.8315 138.834 81.833H174.167C175.382 81.833 176.422 82.2658 177.287 83.1315C178.153 83.9972 178.585 85.0366 178.584 86.2497V99.4997H171.959C168.904 99.4997 166.299 100.577 164.146 102.73C161.992 104.884 160.916 107.488 160.917 110.541V117.166H138.834Z",
    fill: "#005DAA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6715_12023"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 53,
    fill: "white",
    transform: "translate(130 73)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFarecards);
export default __webpack_public_path__ + "static/media/NoFarecards.75081655fadf19a8ae5a3db49ce80598.svg";
export { ForwardRef as ReactComponent };